// Copyright 2021, 2023-2025 - Hewlett Packard Enterprise Company

import { Box } from 'grommet';
import PropTypes from 'prop-types';

const Notification = ({ children, color, icon, pad, ...rest }) => (
  <Box
    direction="row"
    background={color}
    gap="small"
    round="xsmall"
    pad={pad || 'small'}
    {...rest}
  >
    {icon}
    {children}
  </Box>
);

export default Notification;

Notification.propTypes = {
  children: PropTypes.element,
  color: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({ dark: PropTypes.string, light: PropTypes.string }),
  ]),
  icon: PropTypes.element,
  pad: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
